import DeloitteLogo from "../../assets/deloitte.svg";
import HomeIcon from "../../assets/home.svg";
import NotificationIcon from "../../assets/notification.svg";
import ReportIcon from "../../assets/report.svg";
import QuoteUploadIcon from "../../assets/quote-upload.svg";
import QuoteUploadIconDisabled from "../../assets/quote-upload-disabled.svg";
import SettingsIcon from "../../assets/settings.svg";
import MinusIcon from "../../assets/minus.svg";
import PlusIcon from "../../assets/plus.svg";
import GraybarLogo from "../../assets/graybar-logo-v2.png";
import { useEffect, useRef, useState } from "react";
import { NavbarInfo } from "../../services/interfaces/Inavbar";
import { useLocation, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import {
  AccountInfo,
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser";
import { callMsGraph } from "../../services/msalAuth/MSALGraph";
import { loginRequest } from "../../services/msalAuth/authConfig";
import {
  useAppDispatch,
  useAppSelector,
} from "../../services/redux/hooks/hooks";
import { useHomeData, useUserDetails } from "../../react-query/hooks/HHomePage";
import { updateUserDetails } from "../../services/redux/reducer/user.reducer";
import { updateScreenAccess } from "../../services/redux/reducer/disablescreens.reducer";
import { ModuleData } from "../../services/interfaces/IHomePage";
import { disableScreenConfig, Module_Name } from "../../utils/constants";
import {
  useNotificationsCount,
  useNotificationsData,
} from "../../react-query/hooks/HNotifications";
import { appInsights } from "../../router/router";
import UserGuideDownloadIcon from "../../assets/user-guide-download.svg";
import { Modal, SelectPicker, Tooltip, Whisper } from "rsuite";
import { useScreenConfig } from "../../react-query/hooks/HScreenConfig";
import { commodityMap } from "./NavbarConstant";

const Navbar = ({ homeData: homeDataProp }: any) => {
  const userDetailsRedux = useAppSelector((state) => state.user);
  const mapRouteToPage = (route: string) => {
    switch (route) {
      case "/home":
        return "Home";
      case "/quote-assessment":
        return "Negotiations & Allocations : Supplier Quote Assessment";
      case "/allocation":
        return "Negotiations & Allocations : Volume Allocation";
      case "/allocation-summary":
        return "Negotiations & Allocations : Allocation Summary";
      case "/cost-setting":
        return "Board Cost : Board Cost Setting";
      case "/cost-trend":
        return "Board Cost : Board Cost Trend";
      case "/cost-metrics":
        return "Compliance Monitoring : Cost Compliance";
      case "/volume-metrics":
        return "Compliance Monitoring : Volume Compliance";
      case "/nia-opportunity":
        return "NIA Opportunity";
      case "/lvia-tracking":
        return "LVIA Tracking";
      case "/notifications":
        return "Notifications";
      case "/reports":
        return "Reports";
      case "/upload-quote":
        return "Quote Upload";
    }
  };
  const reviewStatus = {
    critical: "border-[#E49257] bg-[#FFF4ED] text-[#CD6318]",
    warn: "border-[#F3DE71] bg-[#FCFAF1] text-[#E9C400]",
    safe: "border-[#79B0E2] bg-[#F0F8FF] text-[#006FD5]",
  };

  const getReviewStatus = (daysLeft: number) => {
    if (daysLeft <= 0) {
      return "critical";
    } else if (daysLeft > 0 && daysLeft <= 10) {
      return "warn";
    } else {
      return "safe";
    }
  };

  const headerNavItems: any = [
    {
      name: "Home",
      route: "home",
      navigateTo: "/home",
      src: HomeIcon,
      alt: "HomeIcon",
      isHidden: true,
    },
    {
      name: "Notifications",
      route: "notifications",
      navigateTo: "/notifications",
      src: NotificationIcon,
      alt: "NotificationIcon",
      isHidden: true,
    },
    {
      name: "Reports",
      route: "reports",
      navigateTo: "/reports",
      src: ReportIcon,
      alt: "ReportIcon",
      isHidden: true,
    },
    {
      name: "Quote Upload",
      route: "upload-quote",
      navigateTo: "/upload-quote",
      src: QuoteUploadIcon,
      alt: "QuoteUploadIcon",
      isHidden: true,
    },
  ];

  const navbar: NavbarInfo[] = [
    {
      name: "Negotiations & Allocations",
      tag: 1,
      fullName: "Negotiations & Allocations",
      route: null,
      internalRoute: [
        {
          name: "Supplier Quote Assessment",
          route: "/quote-assessment",
          isHidden: true,
        },
        {
          name: "Volume Allocation",
          route: "/allocation",
          isHidden: true,
        },
        {
          name: "Allocation Summary",
          route: "/allocation-summary",
          isHidden: true,
        },
      ],
      isHidden: true,
    },
    {
      name: "Board Cost",
      tag: 2,
      fullName: "Board Cost Setting",
      route: null,
      internalRoute: [
        {
          name: "Board Cost Setting",
          route: "/cost-setting",
          isHidden: true,
        },
        {
          name: "Board Cost Trend",
          route: "/cost-trend",
          isHidden: true,
        },
      ],
      isHidden: true,
    },
    {
      name: "Target Monitoring",
      tag: 3,
      fullName: "Target Monitoring",
      route: null,
      internalRoute: [
        {
          name: "Cost Metrics",
          route: "/cost-metrics",
          isHidden: true,
        },
        {
          name: "Volume Metrics",
          route: "/volume-metrics",
          isHidden: true,
        },
      ],
      isHidden: true,
    },
    {
      name: "Rebate Opportunity",
      fullName: "Rebate Opportunity",
      tag: 4,
      route: null,
      internalRoute: [
        {
          name: "NIA Benchmarking",
          route: "/nia-opportunity",
          isHidden: false,
        },
        {
          name: "LVIA Tracking",
          route: "/lvia-tracking",
          isHidden: false,
        },
      ],
      isHidden: true,
    },
    {
      name: "Wire Project Agreements",
      fullName: "Wire Contract Tracking",
      tag: 4,
      route: "/wirecontracts",
      internalRoute: null,
      isHidden: true,
    },
    {
      name: "Settings",
      fullName: "Settings",
      tag: 5,
      route: "/settings",
      internalRoute: null,
      isHidden: true,
      icon: SettingsIcon,
    },
  ];

  const [navbarInfo, setNavbarInfo] = useState<NavbarInfo[] | null>(navbar);
  const [headerNavItemsInfo, setHeaderNavItemsInfo] = useState(headerNavItems);
  const [navActiveState, setNavActiveState] = useState<number>(0);
  const { instance, inProgress } = useMsal();
  const [graphData, setGraphData] = useState<any>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [userEmail, setUserEmail] = useState<string>("");
  const { userDetails, isLoading } = useUserDetails(userEmail);
  // Skip fetching home modules when on "/" or "/home"
  const isHomeRoute =
    location.pathname === "/" || location.pathname === "/home";
  const emailForModules = isHomeRoute
    ? null
    : localStorage.getItem("userEmail");

  const { data: homeDataNew, isLoading: modulesLoading } = useHomeData(
    emailForModules,
    null,
    null,
    isHomeRoute,
  );

  const homeData = isHomeRoute ? homeDataProp : homeDataNew;

  const { screenConfigData, isLoading: screenConfigLoading } =
    useScreenConfig();

  const [route, setRoute] = useState<string>(
    location?.pathname?.split("/")[location?.pathname?.split("/").length - 1],
  );

  const navigateTo = (route: string | null) => {
    if (route) {
      navigate(route);
    }
  };

  let userCommodityArray =
    userDetails?.district_level_data?.map((item: any) => item.COMMODITY) ?? [];

  let arr = userDetails?.district_level_data?.map(
    (item: any) => item?.COMMODITY,
  );

  const uniqueArr = [];

  if (arr && arr.length) {
    for (let i = 0; i < arr.length; i++) {
      if (uniqueArr.indexOf(arr[i]) === -1) {
        uniqueArr.push(arr[i]);
      }
    }
  }

  let { notificationsCount } = useNotificationsCount(
    userDetailsRedux.role_name,
    userDetailsRedux.userCommArray,
    userDetailsRedux.userEmail,
  );

  useEffect(() => {
    setHeaderNavItemsInfo([
      {
        name: "Home",
        route: "home",
        navigateTo: "/home",
        src: HomeIcon,
        alt: "HomeIcon",
        isHidden: userDetailsRedux?.userModuleArray?.length
          ? !userDetailsRedux?.userModuleArray?.includes("HomePage")
          : true,
      },
      {
        name: "Notifications",
        route: "notifications",
        navigateTo: "/notifications",
        src: NotificationIcon,
        alt: "NotificationIcon",
        isHidden: userDetailsRedux.userModuleArray?.length
          ? !userDetailsRedux.userModuleArray.includes("Notifications")
          : true,
      },
      {
        name: "Reports",
        route: "reports",
        navigateTo: "/reports",
        src: ReportIcon,
        alt: "ReportIcon",
        isHidden: userDetailsRedux.userModuleArray?.length
          ? !userDetailsRedux.userModuleArray.includes("Reports")
          : true,
      },
      {
        name: "Quote Upload",
        route: "upload-quote",
        navigateTo: "/upload-quote",
        src: QuoteUploadIcon,
        alt: "QuoteUploadIcon",
        isHidden: userDetailsRedux.userModuleArray?.length
          ? !userDetailsRedux.userModuleArray.includes("Quote Upload")
          : true,
      },
    ]);
    // setNavbarInfo([]);
    if (homeData && Object.keys(homeData).length > 0) {
      let navBarCopy =
        navbarInfo &&
        navbarInfo.map((nav: NavbarInfo) => {
          let i = homeData.data.findIndex(
            (module: ModuleData) =>
              Module_Name[module.name as keyof typeof Module_Name] ===
              nav.fullName,
          );
          if (nav.fullName === "Negotiations & Allocations") {
            const isDimUser = userDetailsRedux.role_name === "DIM";
            nav.internalRoute = [
              {
                name: "Supplier Quote Assessment",
                route: "/quote-assessment",
                isHidden: userDetailsRedux.userModuleArray?.length
                  ? !userDetailsRedux.userModuleArray.includes(
                    "Vendor Quote Assessment",
                  )
                  : true,
              },
              ...(isDimUser
                ? []
                : [
                  {
                    name: "Volume Allocation",
                    route: "/allocation",
                    isHidden: userDetailsRedux.userModuleArray?.length
                      ? !userDetailsRedux.userModuleArray.includes(
                        "Volumne Allocation",
                      )
                      : true,
                  },
                  {
                    name: "Allocation Summary",
                    route: "/allocation-summary",
                    isHidden: userDetailsRedux.userModuleArray?.length
                      ? !userDetailsRedux.userModuleArray.includes(
                        "Allocation Summary",
                      )
                      : true,
                  },
                ]),
            ];
            nav.isHidden = userDetailsRedux.userModuleArray?.length
              ? ![
                "Vendor Quote Assessment",
                "Volumne Allocation",
                "Allocation Summary",
              ].some((module) =>
                userDetailsRedux.userModuleArray.includes(module),
              )
              : true;
          }
          if (nav.fullName === "Board Cost Setting") {
            nav.internalRoute = [
              {
                name: "Board Cost Setting",
                route: "/cost-setting",
                isHidden: userDetailsRedux.userModuleArray?.length
                  ? !userDetailsRedux.userModuleArray.includes(
                    "Board Cost Setting",
                  )
                  : true,
              },
              {
                name: "Board Cost Trend",
                route: "/cost-trend",
                isHidden: userDetailsRedux.userModuleArray?.length
                  ? !userDetailsRedux.userModuleArray.includes(
                    "Board Cost Trends",
                  )
                  : true,
              },
            ];
            nav.isHidden = userDetailsRedux.userModuleArray?.length
              ? !["Board Cost Setting", "Board Cost Trends"].some((module) =>
                userDetailsRedux.userModuleArray.includes(module),
              )
              : true;
          }
          if (nav.fullName === "Target Monitoring") {
            nav.internalRoute = [
              {
                name: "Cost Metrics",
                route: "/cost-metrics",
                isHidden: userDetailsRedux.userModuleArray?.length
                  ? !userDetailsRedux.userModuleArray.includes(
                    "Cost Complaince",
                  )
                  : true,
              },
              {
                name: "Volume Metrics",
                route: "/volume-metrics",
                isHidden: userDetailsRedux.userModuleArray?.length
                  ? !userDetailsRedux.userModuleArray.includes(
                    "Volume Complaince",
                  )
                  : true,
              },
            ];
            nav.isHidden = userDetailsRedux.userModuleArray?.length
              ? !["Cost Complaince", "Volume Complaince"].some((module) =>
                userDetailsRedux.userModuleArray.includes(module),
              )
              : true;
          }
          if (nav.fullName === "Rebate Opportunity") {
            nav.internalRoute = [
              {
                name: "NIA Benchmarking",
                route: "/nia-opportunity",
                isHidden: userDetailsRedux.userModuleArray?.length
                  ? !userDetailsRedux.userModuleArray.includes(
                    "NIA Opportunity",
                  )
                  : true,
              },
              {
                name: "LVIA Tracking",
                route: "/lvia-tracking",
                isHidden: userDetailsRedux.userModuleArray?.length
                  ? !userDetailsRedux.userModuleArray.includes(
                    "Rebate Tracking",
                  )
                  : true,
              },
            ];
            nav.isHidden = userDetailsRedux.userModuleArray?.length
              ? !["NIA Opportunity", "Rebate Tracking"].some((module) =>
                userDetailsRedux.userModuleArray.includes(module),
              )
              : true;
          }
          if (nav.fullName === "Wire Contract Tracking") {
            nav.isHidden = userDetailsRedux.userModuleArray?.length
              ? !userDetailsRedux.userModuleArray.includes(
                "Wire Contract Tracking",
              )
              : true;
          }
          if (i >= 0) {
            nav.days_left_for_review = homeData.data[i].days_left_for_review;
          }
          return nav;
        });
      if (navBarCopy && navBarCopy.length > 0) {
        setNavbarInfo([...navBarCopy]);
      }
    }
  }, [homeData, userDetailsRedux.userModuleArray]);

  useEffect(() => {
    setRoute(
      location?.pathname?.split("/")[location?.pathname?.split("/").length - 1],
    );
    switch (location.pathname) {
      case "/quote-assessment":
        setNavActiveState(1);
        break;
      case "/allocation":
        setNavActiveState(1);
        break;
      case "/allocation-summary":
        setNavActiveState(1);
        break;
      case "/cost-setting":
        setNavActiveState(2);
        break;
      case "/cost-trend":
        setNavActiveState(2);
        break;
      case "/cost-metrics":
        setNavActiveState(3);
        break;
      case "/volume-metrics":
        setNavActiveState(3);
        break;
      case "/nia-opportunity":
        setNavActiveState(4);
        break;
      case "/lvia-tracking":
        setNavActiveState(4);
        break;
      default:
        setNavActiveState(0);
        break;
    }
  }, [location]);

  const firstRender = useRef<boolean>(true);

  const getCommodityToDistricts = (data: any) => {
    const result: any = {};
    if (data) {
      data.forEach((entry: any) => {
        const commodity = entry.COMMODITY;
        const district = entry.DISTRICT;
        if (!result[commodity]) {
          result[commodity] = [];
        }
        result[commodity].push(district);
      });
    }
    return result;
  };

  // Function to get unique commodity array
  const getCommodityArray = (data: any) => {
    const commoditiesSet = new Set();
    if (data) {
      data.forEach((entry: any) => {
        commoditiesSet.add(entry.COMMODITY);
      });
    }
    return Array.from(commoditiesSet);
  };

  useEffect(() => {
    if (!graphData && inProgress === InteractionStatus.None) {
      callMsGraph()
        .then((response) => {
          // props?.updateToken(localStorage.getItem("accessToken"));
          window.localStorage.setItem("userEmail", response.mail);
          setUserEmail(response.mail);
          setGraphData(response);

          let authHandler = localStorage.getItem("authHandler");
          if (authHandler && authHandler === "1") {
            localStorage.setItem("authHandler", "0");
          }
          localStorage.setItem("name", response?.displayName);
          // Logging User Details login
          if (firstRender.current && response !== null) {
            appInsights.setAuthenticatedUserContext(response.mail);
            appInsights.trackEvent({
              name: "User Details",
              properties: {
                email: response.mail,
                timeStamp: new Date().toUTCString(),
                region: Intl.DateTimeFormat().resolvedOptions().timeZone,
              },
            });
            appInsights.startTrackPage("Commodity Connect");
            firstRender.current = false;
          }
        })
        .catch((e) => {
          if (e instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect({
              ...loginRequest,
              account: instance.getActiveAccount() as AccountInfo,
            });
          }
        });
    }
  }, [inProgress, graphData, instance]);

  // useEffect(() => {
  //   if (homeData && Object.keys(homeData).length > 0) {
  //     let navBarCopy =
  //       navbarInfo &&
  //       navbarInfo.map((nav: NavbarInfo) => {
  //         let i = homeData.data.findIndex(
  //           (module: ModuleData) =>
  //             Module_Name[module.name as keyof typeof Module_Name] ===
  //             nav.fullName
  //         );
  //         if (i >= 0) {
  //           nav.days_left_for_review = homeData.data[i].days_left_for_review;
  //         }
  //         return nav;
  //       });
  //     if (navBarCopy && navBarCopy.length > 0) {
  //       setNavbarInfo([...navBarCopy]);
  //     }
  //   }
  // }, [homeData]);

  useEffect(() => {
    if (!screenConfigLoading && !isLoading) {
      dispatch(updateScreenAccess(screenConfigData));
      let userCommArray = getCommodityArray(userDetails?.district_level_data);
      let userCommDisObj = getCommodityToDistricts(
        userDetails?.district_level_data,
      );
      let userModuleArray = userDetails?.module;
      let userCanEditArray = userDetails?.can_edit;
      let resultObj = {
        ...userDetails,
        userCommArray,
        userCommDisObj,
        userModuleArray,
        userCanEditArray,
      };
      dispatch(updateUserDetails(resultObj));
    }
  }, [screenConfigLoading, isLoading, location.pathname]);

  //Metrics to track page duration
  useEffect(() => {
    if (location.pathname === "/") return;
    let startTime = Date.now();

    appInsights.trackPageView({
      name: `${mapRouteToPage(location.pathname)}`,
    });

    return () => {
      if (location.pathname === "/") return;
      const duration = Date.now() - startTime;
      appInsights.trackEvent({
        name: `Duration for ${mapRouteToPage(location.pathname)} - ${duration / 1000
          }s`,
      });
    };
  }, [location]);

  return (
    <div className="h-full border-r-[1px] border-[#BDBDBD] flex flex-col justify-between gap-[1vh]">
      <div className="h-[85vh]">
        {/* Logo */}
        <div className="flex flex-row justify-start gap-1 items-center px-[8%] py-[12%]">
          <img
            className="max-w-[35%] h-[4vh]"
            src={DeloitteLogo}
            alt="Deloitte"
          ></img>
          <span className="bg-[#BEBEBE] h-[3vh] w-[1px]"></span>
          <div className="flex flex-col justify-between items-start">
            <div className="font-extrabold tracking-tight text-[0.7vw]">
              <span className="text-deloitteGreen">Commodity </span>
              <span>Connect</span>
            </div>
          </div>
        </div>

        {/* Nav items */}
        <div className="px-[12%]">
          {headerNavItemsInfo.map((ele: any, i: any) => (
            <>
              {!ele.isHidden && (
                <div
                  key={i}
                  className={`${`flex justify-start items-center cursor-pointer ${ele.route === "home" ? "mb-[0.7vw]" : "my-[0.7vw]"
                    }`}`}
                  onClick={() => {
                    navigateTo(ele.navigateTo);
                  }}
                >
                  <img
                    className="max-w-[35%] h-[2.5vh]"
                    src={ele.src}
                    alt={ele.alt}
                  ></img>
                  <p
                    className={`text-fs16 font-semibold ml-[0.4vw] cursor-pointer ${route === ele.route
                      ? "text-deloitteGreen font-semibold"
                      : ""
                      }`}
                  >
                    {ele.name}
                  </p>
                  {ele.route === "notifications" && notificationsCount > 0 ? (
                    <div
                      className={`text-white flex justify-center items-center h-[0.8vw] w-[0.8vw] bg-deloitteGreen radius-[50%] font-bold text-[0.8vw] ml-[1vw] rounded-full p-[0.7vw] ${notificationsCount > 99
                        ? "p-[0.84vw] h-[1vw] w-[1vw] "
                        : ""
                        }`}
                    >
                      {notificationsCount}
                    </div>
                  ) : null}
                </div>
              )}
            </>
          ))}
        </div>

        {/* Upcoming negotiations */}
        <div className="pl-[12%] pr-[6%]">
          {navbarInfo?.map((val: NavbarInfo, i: number) => (
            <>
              {!val.isHidden && (
                <div
                  key={val.name}
                  className={`${`${!(userDetailsRedux?.userModuleArray?.length === 1) &&
                    "border-t border-t-[#CDCDCD] block text-fs14 mt-[1vw] pt-[0.8vw]"
                    }`}`}
                >
                  {(val.days_left_for_review ||
                    val.days_left_for_review === 0) && (
                      <span
                        className={`border rounded-[50px] font-semibold px-[0.7vw] py-[0.5vh] ${reviewStatus[getReviewStatus(val?.days_left_for_review)]
                          }`}
                      >
                        Review{" "}
                        {val.days_left_for_review && val.days_left_for_review > 0
                          ? `in ${val.days_left_for_review} day${val.days_left_for_review > 1 ? "s" : ""
                          }`
                          : "now"}
                      </span>
                    )}
                  <div
                    className={`flex justify-between items-center cursor-pointer`}
                    onClick={() => {
                      setNavActiveState(
                        navActiveState === val?.tag ? 0 : val?.tag,
                      );
                    }}
                  >
                    <p
                      onClick={() => {
                        navigateTo(val?.route);
                      }}
                      className={`text-fs16 font-semibold my-[0.5dvw] flex items-center gap-[0.3vw] ${route === val?.route?.slice(1)
                        ? "text-deloitteGreen font-semibold"
                        : ""
                        } cursor-pointer`}
                    >
                      {val?.icon && (
                        <img
                          className="h-[2vh] w-[2vh]"
                          src={val.icon}
                          alt={`${val.name}Icon`}
                        />
                      )}
                      {val?.name}
                    </p>
                    {!val?.route && (
                      <img
                        className={`max-w-[35%] h-[2.5vh] cursor-pointer`}
                        src={navActiveState === val?.tag ? MinusIcon : PlusIcon}
                        alt="MinusIcon"
                      ></img>
                    )}
                  </div>
                  {
                    <div
                      className={`pl-[10%] pr-[6%] transition-all duration-300 overflow-hidden ease w-full ${navActiveState === val?.tag ? "max-h-40" : "max-h-0"
                        }`}
                    >
                      {val?.internalRoute?.map((ele) => {
                        const currentScreenAccess =
                          screenConfigData?.[disableScreenConfig[ele?.name]];
                        const isVolumeAllocationDisabled =
                          ele?.name === "Volume Allocation" &&
                          ((typeof currentScreenAccess === "boolean" &&
                            currentScreenAccess === false) ||
                            (typeof currentScreenAccess === "object" &&
                              currentScreenAccess !== null &&
                              Object.values(currentScreenAccess).length > 0 &&
                              !Object.values(currentScreenAccess).some(Boolean)));
                        const isAllocationSummaryDisabled =
                          ele?.name === "Allocation Summary" &&
                          ((typeof currentScreenAccess === "boolean" &&
                            currentScreenAccess === false) ||
                            (typeof currentScreenAccess === "object" &&
                              currentScreenAccess !== null &&
                              Object.values(currentScreenAccess).length > 0 &&
                              !Object.values(currentScreenAccess).some(Boolean)));

                        if (
                          screenConfigData &&
                          (isVolumeAllocationDisabled ||
                            isAllocationSummaryDisabled)
                        ) {
                          return (
                            <>
                              <p
                                key={ele.name}
                                className={`text-fs14 font-semibold cursor-not-allowed text-gray-400`}
                              >
                                <Whisper
                                  speaker={
                                    <Tooltip placement="auto">
                                      Execute Assessment under quote upload to
                                      view {ele?.name?.toLowerCase()}
                                    </Tooltip>
                                  }
                                >
                                  {ele?.name}
                                </Whisper>
                              </p>
                            </>
                          );
                        } else {
                          return (
                            <>
                              {!ele.isHidden && (
                                <p
                                  key={ele.name}
                                  onClick={() => {
                                    navigateTo(ele?.route);
                                  }}
                                  className={`text-fs14 font-semibold cursor-pointer ${route === ele?.route?.slice(1)
                                    ? "text-deloitteGreen font-semibold"
                                    : ""
                                    }`}
                                >
                                  {ele?.name}
                                </p>
                              )}
                            </>
                          );
                        }
                      })}
                    </div>
                  }
                </div>
              )}
            </>
          ))}
        </div>
      </div>
      <div className="w-full h-[13vh] px-[10%]  flex flex-col items-center">
        <div className="max-w-[55%] h-[5vh]">
          <img src={GraybarLogo} alt="Graybar" />
        </div>
        <a
          className="flex flex-row justify-between items-center w-[45%] pt-[2vh]"
          download={"Commodity Connect_User Manual"}
          href={
            userDetailsRedux.role_name === "Manager"
              ? require("../../assets/Connect_Analytics_Platform_User_Manual_FCM_July_2026.pdf")
              : userDetailsRedux.role_name === "DIM"
                ? require("../../assets/user-guide-dim-new.pdf")
                : require("../../assets/user-guide-updated.pdf")
          }
        >
          <img
            className="h-[2vh]"
            src={UserGuideDownloadIcon}
            alt="Download User Guide"
          />
          <div className="text-fs16">User Guide</div>
        </a>
      </div>
      <div className="w-full h-[13vh] px-[10%] flex items-center gap-4">
        <button id="ot-sdk-btn" className="ot-sdk-show-settings text-fs16 font-semibold hover:underline !bg-transparent !border-none !text-current !p-0"

        >Cookie Settings</button>
        <a
          target="_blank"
          className="text-fs16 font-semibold hover:underline hover:text-current active:text-current focus:text-current visited:text-current text-current no-underline"
          href="https://cookienotice.deloitte.com/"
        >
          Cookies
        </a>
      </div>
    </div>
  );
};

export default Navbar;
